export class Viewers {
    userName: string;
    userId: string;
}

export class Activities {
    type: string;
    userName: string;
    userId: string;
    opType: string;
    date: string;
    items: ActivityItem[];
}

export class ActivityItem {
    title: string;
    oldVal: string;
    newVal: string;
}

export const OP_TYPE = {
    'd': 'delete note',
    'r': 'read note',
    'c': 'create note',
    'u': 'made changes'
};

export const TYPE = {
    ADD: 'c',
    DEL: 'd',
    VIEW: 'r',
    EDIT: 'u'
};

export const DOT_TYPE = {
    'c': 'success',
    'u': 'info'
};

export const RNTRY = {
    SENTIMENT: 'sentiment',
    PRIORITY: 'priority',
    SOURCE: 'source',
    SUBJECT: 'subject',
    ENTITIES: 'entities',
    ADHOCS: 'adhocs',
    SUBMITTER: 'submitter',
    FILES: 'files',
    DISPLAY_DATE: 'display-date',
    ENTRY_TYPE: 'entry-type',
    BODY_PATH: 'body-path'
};

export const ENTIMENT = {
    '1': 'Positive',
    '0': 'Neutral',
    '-1': 'Negative'
};

// only entity and date need format, other type display as it is.
export const ADHOC_TYPE = {
    ENTITY: 'entity',
    DATE: 'date',
    TEXTBOX: 'textbox',
    NUMBER: 'number',
    CHECKBOX: 'checkbox'
};

export const ENTRY_VALUE = {
    'sentiment': 'Sentiment',
    'priority': 'Priority',
    'source': 'Source',
    'subject': 'Subject',
    'entities': 'Entities',
    'submitter': 'Submitter',
    'files': 'Attachment',
    'display-date': 'Display Date',
    'entry-type': 'Entry Type',
    'body-path': 'Body'
};
